 export const fakeVideoData = [
    {
      id: 1,
      link: "https://www.youtube.com/watch?v=8OBXCqfbmz8"
    },
    {
      id: 2,
      link: "https://youtu.be/l9u8Zb4fY1c"
    },
    {
      id: 3,
      link: "https://www.youtube.com/watch?v=PYDlW_9RBAo"
    },
    {
      id: 4,
      link: "https://www.youtube.com/watch?v=PYDlW_9RBAo"
    }
  ];
